<template lang='pug'>
  .container
    article
      h2 Impressum
      p Hinweise gem. § 6 des Teledienstegesetzes vom 22. Juli 1997 (BGBl. I S. 1870) in der Fassung des Gesetzes über rechtliche Rahmenbedingungen für den elektronischen Geschäftsverkehr (Elektronischer Geschäftsverkehr-Gesetz – EGG) vom 14. Dezember 2001 (BGBl. I S. 3721):
      p Rechtsanwalt Christoph Schommer ist im Bezirk des Landgerichts Berlin als Rechtsanwalt zugelassen.
      p Er ist bei der Allianz Deutschland AG berufshaftpflichtversichert. Die Bezeichnung der Police nenne ich Ihnen gerne in einem persönlichen Gespräch.
      p Sie erreichen mich unter der Anschrift:
        br
        | Rechtsanwalt Christoph Schommer
        br
        | Albestraße 21
        br
        | 12159 Berlin
        br
        | Telefon: 030 74 75 10 10
      p
        | Rechtsanwalt Christoph Schommer ist Mitglieder der&nbsp;
        strong
          a(href='https://www.rak-berlin.de/', target='_blank') Rechtsanwaltskammer Berlin:
      p
        | Rechtsanwaltskammer Berlin
        br
        | Littenstr. 9 * 10179 Berlin
        br
        | T. (030) 306931-0
        br
        | F. (030) 30693199

      p
        | Rechtsanwalt Christoph Schommer unterliegt den berufsrechtlichen Regelungen in den jeweils geltenden Fassungen.
        br
        strong
          br
          | Berufsrechtliche Regelungen des Rechtsanwalts sind:
          br
        | &ndash;&nbsp;
        a(href='https://bundesrecht.juris.de/bundesrecht/brao/index.html', target='_blank') Bundesrechtsanwaltsordnung
        | &nbsp;(BRAO),
        br
        | &ndash;&nbsp;
        a(href='https://www.rechtsanwaltsgebuehren.de/Berechnen/RAGebBRAGO.html', target='_blank') Bundesrechtsanwaltsgebührenordnung
        | &nbsp;(BRAGO; Mandate bis 30.06.2004)
        br
        | &ndash;&nbsp;
        a(href='http://bundesrecht.juris.de/bundesrecht/rvg/index.html', target='_blank') Rechtsanwaltvergütungsgesetz
        |  (RVG) (Mandate seit 01.07.2004)
        br
        | &ndash; Berufsordnung der Rechtsanwälte (BORA)
        br
        | &ndash; Fachanwaltsordnung (FAO)

      p
        | Sie können in die vorgenannten berufsrechtlichen Regelungen auf den Internetseiten der&nbsp;
        a(href='https://www.brak.de/seiten/06.php', target='_blank') Bundesrechtsanwaltskammer
        |  (Stichwort: Berufsrecht), über die Internetseite des&nbsp;
        a(href='http://bundesrecht.juris.de/bundesrecht/BMJ_index.html', target='_blank') Bundesministerium der Justiz
        |  oder über die Seiten der vorgenannten Rechtsanwaltskammer aus Berlin Einsicht nehmen.

      p Verantwortlicher für den Internetauftritt und Datenschutzbeauftragter i.S.d. Bundesdatenschutzgesetzes ist Rechtsanwalt Christoph Schommer sowie für ihn als bevollmächtigter Vertreter Rechtsanwalt Axel Claussen (claussen@ra-claussen.de).
</template>

<script>
export default {
  name: 'Impressum'
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/content/Impressum.vue